import { memo, type ReactNode } from "react";

import { MeetingEndedState } from "graphql_globals";
import type { Devices } from "common/selected_devices_controller";

import Twilio from "./twilio";
import type { VideoConference as Meeting } from "./index_fragment.graphql";

export type ChildParams<L, R> = {
  localParty: L;
  remoteParties: R[];
};

type Props<L, R> = {
  meeting: Meeting;
  children: (params: ChildParams<L, R>) => ReactNode;
  onDeviceError?: () => void;
  onStopScreenShare?: () => void;
  publishAudio: boolean;
  publishVideo: boolean;
  publishScreenStream?: MediaStream | null;
  selectedDevices: Devices;
  muted: boolean;
  user: {
    id: string;
  };
};

function VideoConference<L, R>({
  muted,
  selectedDevices,
  publishVideo,
  publishScreenStream,
  publishAudio,
  children,
  meeting,
  user,
  onDeviceError,
  onStopScreenShare,
}: Props<L, R>) {
  const { video, meetingParticipants } = meeting;
  return (
    <Twilio<L, R>
      token={video?.token}
      sessionId={video?.id}
      ended={meeting.endedState !== MeetingEndedState.NOT_COMPLETED}
      selectedDevices={selectedDevices}
      publishAudio={publishAudio}
      publishVideo={publishVideo}
      publishScreenStream={publishScreenStream}
      muted={muted}
      user={user}
      meetingParticipants={meetingParticipants}
      onDeviceError={onDeviceError}
      onStopScreenShare={onStopScreenShare}
    >
      {children}
    </Twilio>
  );
}

export default memo(VideoConference) as typeof VideoConference;
